import React from 'react';
import { MaxWidthWrapper, ScrollWrapper, PanelContainer, ContainerWrapper } from './template.styles';
import { JRCContainerProps } from './template.type';

const Container = (
    { children, mode = 'center', maxWidth, flexDirection, hasPadding, backgroundColor, ...props }: JRCContainerProps,
    ref: React.ForwardedRef<HTMLDivElement>,
) => {
    return (
        <ContainerWrapper $flexDirection={flexDirection} backgroundColor={backgroundColor}>
            <ScrollWrapper {...props} ref={ref} $flexDirection={flexDirection}>
                <MaxWidthWrapper
                    $mode={mode}
                    $maxWidth={maxWidth}
                    $flexDirection={flexDirection}
                    $hasPadding={hasPadding}>
                    {children}
                </MaxWidthWrapper>
            </ScrollWrapper>
            <PanelContainer id="jrc-container-panel"></PanelContainer>
        </ContainerWrapper>
    );
};

export const JRCContainer = React.forwardRef(Container);
